// Funciones auxiliares para formato de celdas de tablas.
//import * as FxLog from './FxLog';
import * as FxDat from '../fx/FxDat';
import * as FxNum from '../fx/FxNum';
import { getStoreValue } from "../gx/GxStore";

export const cellToLocalDate = (dt) => {
  return FxDat.toLocalDate(dt);
}

export const cellToLocalTime = (dt) => {
  return FxDat.toLocalTime(dt);
}

export const cellToLocalDateTime = (dt) => {
  return FxDat.toLocalDateTime(dt);
}

export const cellToYesNo = (bo) => {
  let ar = JSON.parse(sessionStorage.getItem('trans') || null);
  let strYes = ar['field.yes'];
  let strNo = ar['field.no'];
  return Boolean(bo === '1') ? strYes : strNo;
}

export const cellToInt = (num) => {
  return FxNum.toInt(num).toString();
}

export const cellTo2r00 = (num) => {
  return FxNum.to2r00(num).toString().replace('.', getStoreValue('StoreSession', 'txDecimalSeparator'));
}

export const cellTo2t00 = (num) => {
  return FxNum.to2t00(num).toString().replace('.', getStoreValue('StoreSession', 'txDecimalSeparator'));
}

export const cellTo4r00 = (num) => {
  return FxNum.to4r00(num).toString().replace('.', getStoreValue('StoreSession', 'txDecimalSeparator'));
}

/** reemplaza valores contenidos en txType por texto especificado. Por ejemplo en las cns reemplaza 'G' por 'General' */
export const replace = (text, options) => {
  let newText = text;
  options.map((option) => (
    newText = (newText===undefined ? newText : newText.toString().replace(option.id, option.text))
  ));
  return newText;
}

export const csvDownload = (_data, _fileName) => {
  // Check if data is valid and not empty
  if (!_data || _data.length === 0) {
    console.error("The data array is empty or null.");
    return;
  }

  // Use the keys of the first object as CSV headers
  const _headers = Object.keys(_data[0]);

  // Convert objects to CSV string format
  const _csv = _data.map((_row) => {
    return _headers
      .map((_fieldName) => {
        // Get the value, handle null/undefined, and enclose in double quotes if it contains a comma or quote
        let _value = _row[_fieldName] === null || _row[_fieldName] === undefined ? "" : String(_row[_fieldName]);
        if (_value.includes(',') || _value.includes('"') || _value.includes('\n')) {
          // Double quotes are escaped by doubling them
          _value = `"${_value.replace(/"/g, '""')}"`;
        }
        return _value;
      })
      .join(',');
  });

  // Add headers to the beginning of the CSV array
  _csv.unshift(_headers.join(','));

  // Create the final CSV content as a single string
  const _csvString = _csv.join('\n');

  // Create a Blob with the CSV content, specifying UTF-8 encoding
  // The 'data:text/csv;charset=utf-8' is not used directly for maximum compatibility
  const _blob = new Blob([_csvString], { type: 'text/csv;charset=utf-8;' });
  
  // Create a URL for the Blob
  const _url = URL.createObjectURL(_blob);

  // Create a temporary link element for the download
  const _link = document.createElement('a');
  _link.setAttribute('href', _url);
  // Default file name if none is provided
  _link.setAttribute('download', `${_fileName || 'export'}.csv`);
  
  // Append link to the document, trigger download, and remove link
  document.body.appendChild(_link);
  _link.click();
  document.body.removeChild(_link);
};

export const csvChangeColumns = (_rawData, _columnsConfig) => {
  // 1. Crear la configuración de encabezados (titles)
  const _headers = _columnsConfig.map((_col) => _col.title);

  // 2. Transformar los datos para quitar/renombrar las columnas
  const _processedData = _rawData.map((_item) => {
    // Para cada objeto de datos, creamos un nuevo objeto con solo las columnas deseadas
    const _newRow = {};
    _columnsConfig.forEach((_col) => {
      // Usamos notación camel para la nueva clave (si la definimos)
      const _newKey = _col.dataKey;
      // La clave del objeto original es _col.key
      _newRow[_newKey] = _item[_col.key];
    });
    return _newRow;
  });

  return { _processedData, _headers };
};
